export default class JobQuizResult {
  #result;
  #mail;
  #hiddenClass = 'u-hidden';
  #storageKey = 'quizMailOpen';

  constructor() {
    this.#result = document.querySelector('.js-quiz-result');
    this.#mail = document.querySelector('.js-quiz-mail');
    this.#init();
  }

  #init() {
    if (this.#mail?.querySelector('.af-success, .acf-notice') || sessionStorage.getItem(this.#storageKey)) {
      this.#showMail();
    }

    document.querySelector('[data-quiz-mail]')
      ?.addEventListener('click', () => this.#showMail());

    this.#mail?.querySelector('[data-quiz-back]')
      ?.addEventListener('click', () => this.#showResult());
  }

  #showMail() {
    sessionStorage.setItem(this.#storageKey, '1');
    this.#result?.classList.add(this.#hiddenClass);
    this.#mail?.classList.remove(this.#hiddenClass);
  }

  #showResult() {
    sessionStorage.removeItem(this.#storageKey);
    this.#mail?.classList.add(this.#hiddenClass);
    this.#result?.classList.remove(this.#hiddenClass);
  }
}
